import { createPerformableConfig, TenantId } from '~/tenants/common/registry';
import { coerceLiteralNumberRequired, FIRST_VERSION_TIMESTAMP, zodNativeEnumOptional } from '~/lib/zod';
import z from 'zod';

export enum McmSlideshowOrientation {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
  BOTH = 'both',
}

export default createPerformableConfig(
  'slideshow',
  {
    [FIRST_VERSION_TIMESTAMP]: z.object({
      version: coerceLiteralNumberRequired(FIRST_VERSION_TIMESTAMP),
      orientation: zodNativeEnumOptional(McmSlideshowOrientation),
    }),
  },
  {
    name: 'Slideshow',
    short: '',
    tenant: TenantId.MOTION_CITY_MEDIA,
    thumbnail: '',
    images: [],
  },
);
